// subscription-data.js

// Make all variables and functions global (window scope)
window.STEPS = ['Product', 'Quantity', 'Frequency', 'Review'];
window.FREQUENCIES = ['Weekly', 'Every Two Weeks', 'Every Four Weeks'];

// These will be populated from the theme settings
window.CATEGORIES = {};
window.ASSET_PATHS = {
  bag: {
    1: 'https://cdn.shopify.com/s/files/1/0223/8891/files/bag-1.png?v=1663645554',
    2: 'https://cdn.shopify.com/s/files/1/0223/8891/files/bag-2.png?v=1663645554',
    3: 'https://cdn.shopify.com/s/files/1/0223/8891/files/bag-3.png?v=1663645554',
    4: 'https://cdn.shopify.com/s/files/1/0223/8891/files/bag-4.png?v=1663645555'
  },
  cookiebox: {
    1: 'https://cdn.shopify.com/s/files/1/0223/8891/files/cookiebox-1.png?v=1663645279',
    2: 'https://cdn.shopify.com/s/files/1/0223/8891/files/cookiebox-2.png?v=1663645279',
    3: 'https://cdn.shopify.com/s/files/1/0223/8891/files/cookiebox-3.png?v=1663645279',
    4: 'https://cdn.shopify.com/s/files/1/0223/8891/files/cookiebox-4.png?v=1663693950'
  },
  teabox: {
    2: 'https://cdn.shopify.com/s/files/1/0223/8891/files/quantity-tea-boxless-2.png?v=1723165404',
    4: 'https://cdn.shopify.com/s/files/1/0223/8891/files/quantity-tea-boxless-4.png?v=1723165403',
    8: 'https://cdn.shopify.com/s/files/1/0223/8891/files/quantity-tea-boxless-8.png?v=1723165403'
  },
  frequency: {}
};

// Add frequency assets
window.FREQUENCY_ASSETS = {
  'Weekly': 'https://cdn.shopify.com/s/files/1/0223/8891/files/frequency-1.png?v=1663631134',
  'Every Two Weeks': 'https://cdn.shopify.com/s/files/1/0223/8891/files/frequency-2.png?v=1663631134',
  'Every Four Weeks': 'https://cdn.shopify.com/s/files/1/0223/8891/files/frequency-4.png?v=1663631133'
};

window.META = {};

const normalizeVariantTitle = (variantTitle, imageType) => {
  const title = (variantTitle || '').trim();
  if (!title || /^default title$/i.test(title)) {
    const fallbackTitles = {
      bag: '1 bag',
      cookiebox: '1 box',
      teabox: '2 oz',
      sachet: '1 pack'
    };
    return fallbackTitles[imageType] || '1 pack';
  }
  return title;
};

// Create a function to get the asset URL based on the quantity type
window.getQuantityAsset = (quantity, imageType) => {
  const match = quantity.match(/(\d+)\s*(oz|pack|bag|box)?/);
  if (!match) return null;

  const [, num] = match;
  const numInt = parseInt(num);

  // Use imageType from product settings if provided, otherwise infer from quantity string
  let assetType = imageType;
  if (!assetType) {
    const type = match[2];
    assetType = type === 'oz' ? 'teabox' :
      type === 'pack' ? 'bag' :
        type === 'box' ? 'cookiebox' : 'bag';
  }

  return ASSET_PATHS[assetType]?.[numInt] || '';
};

// Simplified frequency assets
window.FREQUENCY_INTERVALS = {
  'Weekly': 1,
  'Every Two Weeks': 2,
  'Every Four Weeks': 4
};

// Add function to initialize product data from theme settings
window.initializeProductData = function (productData) {
  const { handle, title, category, imageType, variants, selling_plans, featured_image, product_flavor } = productData;

  // Filter variants - for teabox (tea) products, exclude 1oz since subscriptions only offer 2oz, 4oz, 8oz
  let filteredVariants = variants || [];
  if (imageType === 'teabox' && variants) {
    filteredVariants = variants.filter(variant => {
      const match = variant.title.match(/^1\s*oz$/i);
      return !match; // Exclude 1oz variants
    });
  }

  const hasAvailableVariant = filteredVariants.some(variant => variant.available);

  // Apply 10% subscription discount to prices and round to whole dollars
  const subscriptionDiscount = 0.10;
  const applyDiscount = (price) => Math.round(price * (1 - subscriptionDiscount));
  const discountedPrices = filteredVariants.map(variant => applyDiscount(variant.price / 100));
  const minDiscountedPrice = discountedPrices.length ? Math.min(...discountedPrices) : null;

  // Create product metadata
  window.META[handle] = {
    handle,
    category,
    imageType,
    available: hasAvailableVariant,
    name: title,
    product_flavor: product_flavor || '',
    featured_image: featured_image,
    url: `/products/${handle}`,
    price: minDiscountedPrice !== null ? `from $${minDiscountedPrice}` : '',
    quantities: {},
    plans: {}
  };

  // Map variants to quantities (using filtered variants) with subscription discount
  if (filteredVariants) {
    filteredVariants.forEach(variant => {
      const quantityLabel = normalizeVariantTitle(variant.title, imageType);
      window.META[handle].quantities[quantityLabel] = {
        price: applyDiscount(variant.price / 100),
        originalPrice: variant.price / 100,
        sku: variant.sku,
        id: variant.id,
        inventory_quantity: variant.inventory_quantity,
        available: variant.available
      };
    });
  }

  // Map selling plans
  if (selling_plans && selling_plans.length > 0) {
    selling_plans.forEach(planGroup => {
      if (planGroup.selling_plans) {
        planGroup.selling_plans.forEach(plan => {
          const interval = plan.name.match(/(\d+)/);
          if (interval) {
            const weeks = parseInt(interval[1]);
            const frequency = Object.keys(FREQUENCY_INTERVALS).find(
              f => FREQUENCY_INTERVALS[f] === weeks
            );
            if (frequency) {
              window.META[handle].plans[frequency] = plan.id;
            }
          }
        });
      }
    });
  }
};
